import NameModal from '../Chat/NameModal';
import Button from '../common/Button';
import MinimalFooter from '../common/MinimalFooter';
import MinimalHeader from '../common/MinimalHeader';
import AdvisorBadge from './AdvisorBadge';
import ConsentAccordionSection from './ConsentAccordionSection';
import ContactCard from './ContactCard';
import type { ConsentProps } from './useConsent';
import WarningSection from './WarningSection';

const ConsentMobile = ({
  data,
  accordion1Open,
  accordion2Open,
  toggleAccordion1,
  toggleAccordion2,
  handleAccept,
  handleRefuse,
  canAccept,
  showNameModal,
  handleNameSubmit,
  handleCloseNameModal,
}: ConsentProps) => {
  return (
    <div className="flex min-h-screen max-w-full flex-col overflow-x-hidden bg-surface-primary">
      <MinimalHeader />

      <main className="flex flex-1 flex-col px-4 pt-6 pb-5">
        <div className="flex w-full flex-col gap-4 rounded-xl bg-surface-card p-5 px-[18px] shadow-md">
          <AdvisorBadge text={data.advisorBadge} variant="mobile" />

          <div className="flex flex-col gap-2">
            <h1 className="font-heading text-lg font-semibold text-foreground-primary">
              {data.title}
            </h1>
            <p className="font-body text-[13px] leading-[1.5] text-foreground-secondary">
              {data.subtitle}
            </p>
          </div>

          <div className="flex flex-col gap-3">
            <ConsentAccordionSection
              data={data.accordion1}
              isOpen={accordion1Open}
              onToggle={toggleAccordion1}
              variant="mobile"
            />
            <ConsentAccordionSection
              data={data.accordion2}
              isOpen={accordion2Open}
              onToggle={toggleAccordion2}
              variant="mobile"
            />
          </div>

          <ContactCard
            label={data.contact.label}
            name={data.contact.name}
            email={data.contact.email}
            phone={data.contact.phone}
          />

          <WarningSection
            title={data.warning.title}
            description={data.warning.description}
            variant="mobile"
          />

          <div className="flex flex-col gap-2.5">
            <Button
              variant="solid"
              size="sm"
              fullWidth
              onClick={handleAccept}
              disabled={!canAccept}
              className="rounded-[10px] py-3.5"
            >
              {data.buttons.accept}
            </Button>
            {!canAccept && (
              <p className="text-center text-xs text-foreground-tertiary">
                {data.buttons.disabledHint}
              </p>
            )}
            <Button
              variant="secondary"
              size="sm"
              fullWidth
              onClick={handleRefuse}
              className="rounded-[10px] py-3.5 font-medium"
            >
              {data.buttons.refuse}
            </Button>
          </div>
        </div>
      </main>

      <MinimalFooter variant="mobile" />

      {showNameModal && (
        <NameModal onSubmit={handleNameSubmit} onClose={handleCloseNameModal} />
      )}
    </div>
  );
};

export default ConsentMobile;
